import { createSelector } from 'reselect';
import get from 'lodash/get';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';
import {
  advWorkflow as advWorkflowSelector,
  currentClientId as currentClientIdSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { largePurchaseWorkflowCombinedData } from '../../LargePurchaseWorkflowSelector';

export default createSelector(
  largePurchaseWorkflowCombinedData,
  data => get(data, `${BACKEND_KEY}.Name`, ''),
);

export const largePurchaseNameOrDefaultSelector = createSelector(
  advWorkflowSelector,
  currentClientIdSelector,
  (advWorkflow, clientID) =>
    get(
      advWorkflow,
      `${clientID}.data2.${BACKEND_KEY}.Name`,
      get(advWorkflow, `${clientID}.data.${BACKEND_KEY}.Name`, ''),
    ),
);

export const largePurchaseIdOrDefaultSelector = createSelector(
  advWorkflowSelector,
  currentClientIdSelector,
  (advWorkflow, clientID) =>
    get(
      advWorkflow,
      `${clientID}.data2.${BACKEND_KEY}.Id`,
      get(advWorkflow, `${clientID}.data.${BACKEND_KEY}.Id`, ''),
    ),
);
